const ITEMS = [
  "Monosplit posé dès 2 500 €",
  "Installation sous 15 jours",
  "Zéro sous-traitance",
  "Installateur RGE",
  "Daikin",
  "Étude sur place gratuite",
  "Gironde · Charente · Dordogne · Landes",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap font-display text-lg font-bold text-forest sm:text-xl">
          {item}
        </span>
        <span className="mx-8 h-1.5 w-1.5 shrink-0 rounded-full bg-ice" />
      </span>
    ))}
  </div>
);

export default function ClimMarquee() {
  return (
    <section
      data-testid="clim-marquee"
      className="relative overflow-hidden border-y border-glacier-border bg-ice-light py-5"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
